import { useNotifications } from "@faire/retailer-visitor-shared/components/Header/HeaderNotifications/hooks/useNotifications";
import isUndefined from "lodash/isUndefined";
import { useMemo } from "react";

export const useNotificationPreview = () => {
  const { notifications } = useNotifications();
  const preview = useMemo(
    () =>
      notifications?.find(
        (notification) =>
          notification.priority === "HIGH" &&
          isUndefined(notification.nudge_dismissed_at)
      ),
    [notifications]
  );
  return preview;
};
